import 'babel-polyfill';
import Es6Promise from 'es6-promise';
import Vue from 'vue';
import sensors from '@/sensorsdata';
import App from './App.vue';
import store from './store';
import router from './router';
import api from './api';
import '@/assets/css/custom.scss';
import '@/styles/index.less';
// 加载第三方字体文件
import '@/styles/fonts/font.less';
import { Button, Field, Uploader, Swipe, SwipeItem, Cell, CellGroup, ActionSheet, Toast, Loading, Dialog, List, PullRefresh, PasswordInput, Search, Tab, Tabs, Icon, Progress, Checkbox, Popup, Collapse, CollapseItem } from 'vant';
// 自动设置REM基准值
import 'amfe-flexible';
import track from '@/directives/track';
import VueLazyLoad from 'vue-lazyload';
import VueMasonry from 'vue-masonry-css';
import ProcessDialog from '@/components/processDialog';
import CuccConfirmDialog from '@/components/cuccConfirmDialog';
import TelecomConfirmDialog from '@/components/telecomConfirmDialog';
import CuccOrderDialog from '@/components/cuccOrderDialog';
import CuccOrderPopup from '@/components/CuccOrderPopup';
import '@/utils/errorMonitor';
import { sync } from 'vuex-router-sync';
import Component from 'vue-class-component';
// 注册路由钩子
Component.registerHooks([
    'beforeRouteEnter',
    'beforeRouteLeave',
    'beforeRouteUpdate'
]);
Vue.use(track);
Vue.use(ProcessDialog);
// Use import instead of require for TypeScript compatibility
Es6Promise.polyfill();
Vue.use(VueLazyLoad, {
    preLoad: '10px',
    observer: true
});
Vue.config.devtools = true;
Vue.prototype.$http = api;
Vue.prototype.$EventBus = new Vue();
Vue.use(Button)
    .use(Icon)
    .use(Field)
    .use(Uploader)
    .use(Swipe)
    .use(SwipeItem)
    .use(Cell)
    .use(CellGroup)
    .use(ActionSheet)
    .use(Toast)
    .use(Loading)
    .use(Dialog)
    .use(List)
    .use(PullRefresh)
    .use(Search)
    .use(Tab)
    .use(Tabs)
    .use(PasswordInput)
    .use(VueMasonry)
    .use(Checkbox)
    .use(CuccConfirmDialog)
    .use(Progress)
    .use(Popup)
    .use(Collapse)
    .use(CollapseItem)
    .use(TelecomConfirmDialog)
    .use(CuccOrderDialog)
    .use(CuccOrderPopup);
window.document.documentElement.setAttribute('data-theme', 'light');
Toast.setDefaultOptions({ className: 'them-style' });
Vue.config.productionTip = false;
Vue.config.ignoredElements = [/^qa-router-button|templates|styles/];
router.beforeEach((to, _from, next) => {
    const urlData = to.query || {};
    const os16Version = Number(urlData.versionCode) >= 191116000;
    Vue.prototype.$os14 = true;
    Vue.prototype.$os16 = os16Version;
    next();
});
router.afterEach((to, from) => {
    // 确保 DOM 更新完成后再发送
    Vue.nextTick(() => {
        const referrerUrl = from.path === '/' ? document.referrer : window.location.origin + from.fullPath;
        console.log('pageview');
        sensors.track('$pageview', {
            page_source: to.query.pageSource || '',
            $title: document.title,
            $url: window.location.href,
            $referrer: referrerUrl
        });
    });
});
new Vue({
    router,
    store,
    render: (h) => h(App)
}).$mount('#app');
sync(store, router, { moduleName: 'RouteModule' });
